import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable()
export class ComunicacionService {
    readonly SIN_DATA = "SIN_DATA";

    constructor(
        private _snackBar: MatSnackBar
    ) { }

    /**
     * retorna los datos desde una respuesta de servidor
     * si da error retorna "NO_DATOS" y muestra un mensaje en pantalla
     * @param rspSv 
     */
    format(rspSv, mostrar_mensaje_cuando_responde_ok: boolean) {
        if (rspSv && rspSv.data && rspSv.estado == 1) {
            this._snackBar.dismiss();
            if (mostrar_mensaje_cuando_responde_ok && rspSv.mensaje)
                this._snackBar.open(rspSv.mensaje, 'OK', { duration: 4750 });
            return rspSv.data;
        } else {
            // this._snackBar.open(rspSv.mensaje, 'OK', { duration: 4750 });
        }

        return this.SIN_DATA;
    }

}